import {ShopifyVariant} from './shopify-product.interface';
import {ProductImage} from './product.interface';

interface CartInterface {
  checkout_url: string;
  products: Array<ShoppingCartVariant | CheckoutVariant>;
  cart: Array<CheckoutVariant>;
  subtotal_price: string;
  last_update?: number;
}

export interface ShoppingCartInterface extends CartInterface {
  checkout_id: string;
  currency_code: string;
  language_code: string;
}

export interface IdealCartInterface {
  session_id: string;
  products: Array<IdealShoppingCartVariant>;
  last_update?: number;
}

interface CartVariant {
  image: ProductImage;
  quantity: number;
  title: string;
  sphere_name: string;
  quantity_available: number;
}

export interface IdealCartRequest {
  sku: string;
  qty?: number;
  session_id: string;
  currency_code: string;
  language_code: string;
}

export interface IdealShoppingCartVariant extends CartVariant {
  sku: string;
  price: string;
}

export interface ErrorResponseInterface extends Response {
  response: Array<string>;
}

export interface CheckoutVariant {
  merchandiseId: string;
  quantity: number;
  attributes: ShopifyVariant['attributes'];
}

export interface ShoppingCartVariant extends ShopifyVariant, CartVariant {
  store_url: string;
  compare_at_price_v2: string;
  product_id: string;
  per_order_limit?: number;
  merchandise_id: string;
}

export enum EventType {
  Start = 0,
  Data = 1,
  End = 2
}

export interface ShoppingCartBaseInterface {
  readonly getMultipassToken: string;

  attachShoppingCartToUser(): void;

  clearShoppingCartToken(): void;

  checkMultipassToken(): Promise<void>;

  updateShoppingCartCurrency(currencyCode: string): Promise<void>;

  generateMultipassLink(link: string): Promise<{link: string} | void>;

  storeEmail(email: string | undefined): void;
}
